import { IApiDataType } from '../types'
import useFarwestPmixCategoryData, {
  farwestPmixCategoryDataConfigs,
} from './farwestPmix/useFarwestPmixCategoryData'
import useFarwestPmixItemData, {
  farwestPmixItemDataConfigs,
} from './farwestPmix/useFarwestPmixItemData'
import useFarwestPmixSubcategoryData, {
  farwestPmixSubcategoryDataConfigs,
} from './farwestPmix/useFarwestPmixSubcategoryData'
import useAcePopDailyFlash, {
  acePopDailyFlashConfigs,
} from './useAcePopDailyFlash'
import useAcePopDailyFlashAverage, {
  acePopDailyFlashAverageConfigs,
} from './useAcePopDailyFlashAverage'
import useAcePopPeriodPurchase, {
  acePopPeriodPurchaseConfigs,
} from './useAcePopPeriodPurchase'
import useAcePopWeeklyFlash, {
  acePopWeeklyFlashConfigs,
} from './useAcePopWeeklyFlash'
import useArbListLocationGroupPrimantiTattleCategoryRating, {
  arbListLocationGroupPrimantiTattleCategoryRatingConfigs,
} from './useArbListLocationGroupPrimantiTattleCategoryRating'
import useArbListLocationPrimantiTattleCategoryRating, {
  arbListLocationPrimantiTattleCategoryRatingConfigs,
} from './useArbListLocationPrimantiTattleCategoryRating'
import useArbPrimantiTattle, {
  arbPrimantiTattleConfigs,
} from './useArbPrimantiTattle'
import useBbbExpenses, { bbbExpensesConfigs } from './useBbbExpenses'
import useBbbFlash, { bbbFlashConfigs } from './useBbbFlash'
import {
  bbbGroupPnLConfigs,
  useBbbGroupCtrlExpenses,
  useBbbGroupFnp,
  useBbbGroupLabor,
  useBbbGroupSales,
} from './useBbbGroupPnL'
import useBbbHaccps, { bbbHaccpsConfigs } from './useBbbHaccps'
import {
  bbbPnLConfigs,
  useBbbCtrlExpenses,
  useBbbFnp,
  useBbbLabor,
  useBbbSales,
} from './useBbbPnL'
import useBbbSystemwideOverviewKpis, {
  bbbSystemwideOverviewKpisConfigs,
} from './useBbbSystemwideOverviewKpis'
import useBibibopListLocationKpis, {
  bibibopListLocationKpisConfigs,
} from './useBibibopListLocationKpis'
import useBibibopListNewLocationKpis, {
  bibibopListNewLocationKpisConfigs,
} from './useBibibopListNewLocationKpis'
import {
  corporateExpoAiDeliverySummaryConfigs,
  useCorporateExpoAiDeliveryLocationDetails,
  useCorporateExpoAiDeliverySummary,
} from './useCorporateExpoAiDeliverySummary'
import {
  corporateExpoAiLaborSummaryConfigs,
  useCorporateExpoAiLaborLocationDetails,
  useCorporateExpoAiLaborSummary,
} from './useCorporateExpoAiLaborSummary'
import {
  corporateExpoAiLossPreventionSummaryConfigs,
  useCorporateExpoAiLossPreventionLocationDetails,
  useCorporateExpoAiLossPreventionSummary,
  useCorporateExpoAiLossPreventionSummaryFormat2,
} from './useCorporateExpoAiLossPreventionSummary'
import {
  corporateExpoAiSalesSummaryConfigs,
  useCorporateExpoAiSalesLocationDetails,
  useCorporateExpoAiSalesSummary,
} from './useCorporateExpoAiSalesSummary'
import {
  corporateExpoAiSmgSummaryConfigs,
  useCorporateExpoAiSmgLocationDetails,
  useCorporateExpoAiSmgSummary,
} from './useCorporateExpoAiSmgSummary'
import {
  corporatePnlConfigs,
  useCorporatePnLNetProfit,
  useCorporatePnlExpenses,
  useCorporatePnlFoodCost,
  useCorporatePnlLaborCost,
  useCorporatePnlSales,
} from './useCorporatePnl'
import useFarwestCheckAverageCharts, {
  farwestCheckAverageChartsConfigs,
} from './useFarwestCheckAverageCharts'
import useFarwestCogsTrackerCaseCounts, {
  farwestCogsTrackerCaseCountsConfigs,
} from './useFarwestCogsTrackerCaseCounts'
import useFarwestCorporateExpoAiLossPreventionDetails, {
  farwestCorporateExpoAiLossPreventionDetailsConfigs,
} from './useFarwestCorporateExpoAiLossPreventionDetails'
import useFarwestCorporateExpoAiLossPreventionSummary, {
  farwestCorporateExpoAiLossPreventionSummaryConfigs,
} from './useFarwestCorporateExpoAiLossPreventionSummary'
import useFarwestDailyOps, {
  farwestDailyOpsConfigs,
} from './useFarwestDailyOps'
import useFarwestEquivalentUnitCount, {
  farwestEquivalentUnitCountConfigs,
} from './useFarwestEquivalentUnitCount'
import useFarwestFiveWeekItemTrendData, {
  farwestFiveWeekItemTrendDataConfigs,
} from './useFarwestFiveWeekItemTrendData'
import useFarwestFiveWeekProduceItemTrendData, {
  farwestFiveWeekProduceItemTrendDataConfigs,
} from './useFarwestFiveWeekProduceItemTrendData'
import {
  farwestFlashSalesByOrderModeConfigs,
  useFarwestAverageWeeklySalesbyOrderMode,
  useFarwestTotalSalesPercentbyOrderMode,
  useFarwestTotalSalesbyOrderMode,
} from './useFarwestFlashSalesByOrderMode'
import useFarwestFourWeekTrendData, {
  farwestFourWeekTrendDataConfigs,
} from './useFarwestFourWeekTrendData'
import useFarwestOutliers, {
  farwestOutliersConfigs,
} from './useFarwestOutliers'
import useFarwestSalesCharts, {
  farwestSalesChartsConfigs,
} from './useFarwestSalesCharts'
import useFarwestSssCharts, {
  farwestSssChartsConfigs,
} from './useFarwestSssCharts'
import useFarwestTimeClock, {
  farwestTimeClockConfigs,
} from './useFarwestTimeClock'
import useFarwestTrendDailySplh, {
  farwestTrendDailySplhConfigs,
} from './useFarwestTrendDailySplh'
import {
  farwestWeeklyLaborTrackerConfigs,
  useFarwestWeeklyLaborTracker,
  useFarwestWeeklyLaborTrackerWithNotOpenStores,
} from './useFarwestWeeklyLaborTracker'
import useFlash, { flashConfigs } from './useFlash'
import useIrmgBkPlaid, { irmgBkPlaidConfigs } from './useIrmgBkPlaid'
import useJscBaseballCard, {
  jscBaseballCardConfigs,
} from './useJscBaseballCard'
import useJscCorporateDevelopmentFeedback, {
  jscCorporateDevelopmentFeedbackConfigs,
} from './useJscCorporateDevelopmentFeedback'
import useJscCorporateDevelopmentPlan, {
  jscCorporateDevelopmentPlanConfigs,
} from './useJscCorporateDevelopmentPlan'
import useJscCorporateTrainingTracker, {
  jscCorporateTrainingTrackerConfigs,
} from './useJscCorporateTrainingTracker'
import useJscDevelopmentPlan, {
  jscDevelopmentPlanConfigs,
} from './useJscDevelopmentPlan'
import useJscDevelopmentTrackerFeedback, {
  jscDevelopmentTrackerFeedbackConfigs,
} from './useJscDevelopmentTrackerFeedback'
import useLfrBusinessReview, {
  lfrBusinessReviewConfigs,
} from './useLfrBusinessReview'
import useLfrListLocationBusinessReview, {
  lfrListLocationBusinessReviewConfigs,
} from './useLfrListLocationBusinessReview'
import useLfrListLocationGroupBusinessReview, {
  lfrListLocationGroupBusinessReviewConfigs,
} from './useLfrListLocationGroupBusinessReview'
import useLfrListLocationGuest, {
  lfrListLocationGuestConfigs,
} from './useLfrListLocationGuest'
import useLfrYardi, { lfrYardiConfigs } from './useLfrYardi'
import {
  pnlConfigs,
  usePnlExpenses,
  usePnlFoodCost,
  usePnlLaborCost,
  usePnlSales,
} from './usePnl'
import useSystemwideOverview, {
  systemwideOverviewConfigs,
} from './useSystemwideOverview'
import {
  uploadReportStatusConfigs,
  useFarwestUploadReportStatus,
  useLfrUploadGfpReportStatus,
  useWingitnorthUploadReportStatus,
} from './useUploadReportStatus'
import useUserEvents, { userEventsConfigs } from './useUserEvents'
import useWingitnorthCheckAverageCharts, {
  wingitnorthCheckAverageChartsConfigs,
} from './useWingitnorthCheckAverageCharts'
import useWingitnorthDailyFlash, {
  wingitnorthDailyFlashConfigs,
} from './useWingitnorthDailyFlash'
import useWingitnorthSalesCharts, {
  wingitnorthSalesChartsConfigs,
} from './useWingitnorthSalesCharts'
import useWingitnorthSssCharts, {
  wingitnorthSssChartsConfigs,
} from './useWingitnorthSssCharts'

export type IApiKeyType = keyof typeof api

export const configs = {
  lfrListLocationGuest: lfrListLocationGuestConfigs,
  lfrListLocationGroupBusinessReview: lfrListLocationGroupBusinessReviewConfigs,
  lfrListLocationBusinessReview: lfrListLocationBusinessReviewConfigs,
  lfrBusinessReview: lfrBusinessReviewConfigs,
  jscDevelopmentPlan: jscDevelopmentPlanConfigs,
  jscCorporateDevelopmentFeedback: jscCorporateDevelopmentFeedbackConfigs,
  jscCorporateDevelopmentPlan: jscCorporateDevelopmentPlanConfigs,
  jscCorporateTrainingTracker: jscCorporateTrainingTrackerConfigs,
  jscBaseballCard: jscBaseballCardConfigs,
  irmgBkPlaid: irmgBkPlaidConfigs,
  arbListLocationGroupPrimantiTattleCategoryRating:
    arbListLocationGroupPrimantiTattleCategoryRatingConfigs,
  arbListLocationPrimantiTattleCategoryRating:
    arbListLocationPrimantiTattleCategoryRatingConfigs,
  arbPrimantiTattle: arbPrimantiTattleConfigs,
  systemwideOverview: systemwideOverviewConfigs,
  jscDevelopmentTrackerFeedback: jscDevelopmentTrackerFeedbackConfigs,
  flash: flashConfigs,
  wingitnorthDailyFlash: wingitnorthDailyFlashConfigs,
  lfrYardi: lfrYardiConfigs,
  bibibopListLocationKpis: bibibopListLocationKpisConfigs,
  bibibopListNewLocationKpis: bibibopListNewLocationKpisConfigs,
  lfrUploadGfpReportStatus: uploadReportStatusConfigs,
  farwestUploadReportStatus: uploadReportStatusConfigs,
  wingitnorthUploadReportStatus: uploadReportStatusConfigs,
  userEvents: userEventsConfigs,
  farwestDailyOps: farwestDailyOpsConfigs,
  farwestWeeklyLaborTracker: farwestWeeklyLaborTrackerConfigs,
  farwestWeeklyLaborTrackerWithNotOpenStores: farwestWeeklyLaborTrackerConfigs,
  farwestFiveWeekItemTrendData: farwestFiveWeekItemTrendDataConfigs,
  farwestFourWeekTrendData: farwestFourWeekTrendDataConfigs,
  bbbSystemwideOverviewKpis: bbbSystemwideOverviewKpisConfigs,
  farwestOutliers: farwestOutliersConfigs,
  farwestFlashCogsTrackerCaseCounts: farwestCogsTrackerCaseCountsConfigs,
  farwestTrendDailySplh: farwestTrendDailySplhConfigs,
  farwestAverageWeeklySalesbyOrderMode: farwestFlashSalesByOrderModeConfigs,
  farwestTotalSalesbyOrderMode: farwestFlashSalesByOrderModeConfigs,
  farwestTotalSalesPercentbyOrderMode: farwestFlashSalesByOrderModeConfigs,
  farwestTotalSalesPercentbyDeliveryMode: farwestFlashSalesByOrderModeConfigs,
  farwestEquivalentUnitCount: farwestEquivalentUnitCountConfigs,
  farwestFlashPmixCategoryData: farwestPmixCategoryDataConfigs,
  farwestFlashPmixSubcategoryData: farwestPmixSubcategoryDataConfigs,
  farwestFlashPmixItemData: farwestPmixItemDataConfigs,
  farwestFlashTimeClock: farwestTimeClockConfigs,
  bbbHaccps: bbbHaccpsConfigs,
  bbbExpenses: bbbExpensesConfigs,
  acePopDailyFlash: acePopDailyFlashConfigs,
  acePopPeriodPurchase: acePopPeriodPurchaseConfigs,
  acePopDailyFlashAverage: acePopDailyFlashAverageConfigs,
  acePopWeeklyFlash: acePopWeeklyFlashConfigs,
  bbbSales: bbbPnLConfigs,
  bbbFnp: bbbPnLConfigs,
  bbbLabor: bbbPnLConfigs,
  bbbCtrlExpenses: bbbPnLConfigs,
  bbbGroupSales: bbbGroupPnLConfigs,
  bbbGroupFnp: bbbGroupPnLConfigs,
  bbbGroupLabor: bbbGroupPnLConfigs,
  bbbGroupCtrlExpenses: bbbGroupPnLConfigs,
  bbbFlash: bbbFlashConfigs,
  farwestSalesCharts: farwestSalesChartsConfigs,
  farwestCheckAverageCharts: farwestCheckAverageChartsConfigs,
  farwestSssCharts: farwestSssChartsConfigs,
  farwestFiveWeekProduceItemTrendData:
    farwestFiveWeekProduceItemTrendDataConfigs,
  corporateExpoAiLossPreventionSummary:
    corporateExpoAiLossPreventionSummaryConfigs,
  corporateExpoAiLossPreventionSummaryFormat2:
    corporateExpoAiLossPreventionSummaryConfigs,
  corporateExpoAiLossPreventionLocationDetails:
    corporateExpoAiLossPreventionSummaryConfigs,
  corporateExpoAiSmgSummary: corporateExpoAiSmgSummaryConfigs,
  corporateExpoAiSmgLocationDetails: corporateExpoAiSmgSummaryConfigs,
  corporateExpoAiLaborSummary: corporateExpoAiLaborSummaryConfigs,
  corporateExpoAiLaborLocationDetails: corporateExpoAiLaborSummaryConfigs,
  corporateExpoAiSalesSummary: corporateExpoAiSalesSummaryConfigs,
  corporateExpoAiSalesLocationDetails: corporateExpoAiSalesSummaryConfigs,
  corporateExpoAiDeliverySummary: corporateExpoAiDeliverySummaryConfigs,
  corporateExpoAiDeliveryLocationDetails: corporateExpoAiDeliverySummaryConfigs,
  farwestCorporateExpoAiLossPreventionSummary:
    farwestCorporateExpoAiLossPreventionSummaryConfigs,
  farwestCorporateExpoAiLossPreventionDetails:
    farwestCorporateExpoAiLossPreventionDetailsConfigs,
  corporatePnlSales: corporatePnlConfigs,
  corporatePnlFoodCost: corporatePnlConfigs,
  corporatePnlLaborCost: corporatePnlConfigs,
  corporatePnlExpenses: corporatePnlConfigs,
  corporatePnlNetProfit: corporatePnlConfigs,
  pnlSales: pnlConfigs,
  pnlFoodCost: pnlConfigs,
  pnlLaborCost: pnlConfigs,
  pnlExpenses: pnlConfigs,
  wingitnorthCheckAverageCharts: wingitnorthCheckAverageChartsConfigs,
  wingitnorthSalesCharts: wingitnorthSalesChartsConfigs,
  wingitnorthSssCharts: wingitnorthSssChartsConfigs,
}

export const api = {
  lfrListLocationGuest: useLfrListLocationGuest,
  lfrListLocationGroupBusinessReview: useLfrListLocationGroupBusinessReview,
  lfrListLocationBusinessReview: useLfrListLocationBusinessReview,
  lfrBusinessReview: useLfrBusinessReview,
  jscDevelopmentPlan: useJscDevelopmentPlan,
  jscCorporateDevelopmentFeedback: useJscCorporateDevelopmentFeedback,
  jscCorporateDevelopmentPlan: useJscCorporateDevelopmentPlan,
  jscCorporateTrainingTracker: useJscCorporateTrainingTracker,
  jscBaseballCard: useJscBaseballCard,
  irmgBkPlaid: useIrmgBkPlaid,
  arbListLocationGroupPrimantiTattleCategoryRating:
    useArbListLocationGroupPrimantiTattleCategoryRating,
  arbListLocationPrimantiTattleCategoryRating:
    useArbListLocationPrimantiTattleCategoryRating,
  arbPrimantiTattle: useArbPrimantiTattle,
  systemwideOverview: useSystemwideOverview,
  jscDevelopmentTrackerFeedback: useJscDevelopmentTrackerFeedback,
  flash: useFlash,
  wingitnorthDailyFlash: useWingitnorthDailyFlash,
  lfrYardi: useLfrYardi,
  bibibopListLocationKpis: useBibibopListLocationKpis,
  bibibopListNewLocationKpis: useBibibopListNewLocationKpis,
  lfrUploadGfpReportStatus: useLfrUploadGfpReportStatus,
  farwestUploadReportStatus: useFarwestUploadReportStatus,
  wingitnorthUploadReportStatus: useWingitnorthUploadReportStatus,
  userEvents: useUserEvents,
  farwestDailyOps: useFarwestDailyOps,
  farwestWeeklyLaborTracker: useFarwestWeeklyLaborTracker,
  farwestWeeklyLaborTrackerWithNotOpenStores:
    useFarwestWeeklyLaborTrackerWithNotOpenStores,
  farwestFiveWeekItemTrendData: useFarwestFiveWeekItemTrendData,
  farwestFourWeekTrendData: useFarwestFourWeekTrendData,
  bbbSystemwideOverviewKpis: useBbbSystemwideOverviewKpis,
  farwestOutliers: useFarwestOutliers,
  farwestFlashCogsTrackerCaseCounts: useFarwestCogsTrackerCaseCounts,
  farwestTrendDailySplh: useFarwestTrendDailySplh,
  farwestAverageWeeklySalesbyOrderMode: useFarwestAverageWeeklySalesbyOrderMode,
  farwestTotalSalesbyOrderMode: useFarwestTotalSalesbyOrderMode,
  farwestTotalSalesPercentbyOrderMode: useFarwestTotalSalesPercentbyOrderMode,
  farwestEquivalentUnitCount: useFarwestEquivalentUnitCount,
  farwestFlashPmixCategoryData: useFarwestPmixCategoryData,
  farwestFlashPmixSubcategoryData: useFarwestPmixSubcategoryData,
  farwestFlashPmixItemData: useFarwestPmixItemData,
  farwestFlashTimeClock: useFarwestTimeClock,
  bbbHaccps: useBbbHaccps,
  bbbExpenses: useBbbExpenses,
  acePopDailyFlash: useAcePopDailyFlash,
  acePopPeriodPurchase: useAcePopPeriodPurchase,
  acePopDailyFlashAverage: useAcePopDailyFlashAverage,
  acePopWeeklyFlash: useAcePopWeeklyFlash,
  bbbSales: useBbbSales,
  bbbFnp: useBbbFnp,
  bbbLabor: useBbbLabor,
  bbbCtrlExpenses: useBbbCtrlExpenses,
  bbbGroupSales: useBbbGroupSales,
  bbbGroupFnp: useBbbGroupFnp,
  bbbGroupLabor: useBbbGroupLabor,
  bbbGroupCtrlExpenses: useBbbGroupCtrlExpenses,
  bbbFlash: useBbbFlash,
  farwestSalesCharts: useFarwestSalesCharts,
  farwestCheckAverageCharts: useFarwestCheckAverageCharts,
  farwestSssCharts: useFarwestSssCharts,
  farwestFiveWeekProduceItemTrendData: useFarwestFiveWeekProduceItemTrendData,
  corporateExpoAiLossPreventionSummary: useCorporateExpoAiLossPreventionSummary,
  corporateExpoAiLossPreventionSummaryFormat2:
    useCorporateExpoAiLossPreventionSummaryFormat2,
  corporateExpoAiLossPreventionLocationDetails:
    useCorporateExpoAiLossPreventionLocationDetails,
  corporateExpoAiSmgSummary: useCorporateExpoAiSmgSummary,
  corporateExpoAiSmgLocationDetails: useCorporateExpoAiSmgLocationDetails,
  corporateExpoAiLaborSummary: useCorporateExpoAiLaborSummary,
  corporateExpoAiLaborLocationDetails: useCorporateExpoAiLaborLocationDetails,
  corporateExpoAiSalesSummary: useCorporateExpoAiSalesSummary,
  corporateExpoAiSalesLocationDetails: useCorporateExpoAiSalesLocationDetails,
  corporateExpoAiDeliverySummary: useCorporateExpoAiDeliverySummary,
  corporateExpoAiDeliveryLocationDetails:
    useCorporateExpoAiDeliveryLocationDetails,
  farwestCorporateExpoAiLossPreventionSummary:
    useFarwestCorporateExpoAiLossPreventionSummary,
  farwestCorporateExpoAiLossPreventionDetails:
    useFarwestCorporateExpoAiLossPreventionDetails,
  corporatePnlSales: useCorporatePnlSales,
  corporatePnlFoodCost: useCorporatePnlFoodCost,
  corporatePnlLaborCost: useCorporatePnlLaborCost,
  corporatePnlExpenses: useCorporatePnlExpenses,
  corporatePnlNetProfit: useCorporatePnLNetProfit,
  pnlSales: usePnlSales,
  pnlFoodCost: usePnlFoodCost,
  pnlLaborCost: usePnlLaborCost,
  pnlExpenses: usePnlExpenses,
  wingitnorthCheckAverageCharts: useWingitnorthCheckAverageCharts,
  wingitnorthSalesCharts: useWingitnorthSalesCharts,
  wingitnorthSssCharts: useWingitnorthSssCharts,
}

const useApi = (
  apiName: IApiKeyType,
): {
  data: IApiDataType
  uniqueKey?: string
  loading: boolean
} => api[apiName]()

export default useApi
